import { useEffect, useState } from "react";
import { toastText } from "utils/utils";
import InventoryTable from "../receiveInventoryTable";
import { TableActionHeader } from "components/Global";
import { AddSvg } from "utils/svgs";
import InventoryEditModal from "../Inventory/InventoryEditModel";
import { getApi, deleteApiWithData } from "redux/apis";
import { useSelector, useDispatch } from "react-redux";
import { InventoryProps } from "../Inventory/types";
import dayjs from "dayjs";
import { setServiceCenterSelection } from "redux/slice/inventoryServiceCenterSlice";
import InventoryTableNew from "../Inventory/AddInventoryModell";
import ConfirmDelete from "components/Global/confirmDeleteModel";
const ReceiveInventoryComponent = (props: InventoryProps) => {
  const { refetchCounts } = props;
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");
  const [allInventoryData, setAllInventoryData] = useState<any>([]);
  const [isAddInventoryModalOpen, setIsAddInventoryModalOpen] = useState(false);
  const [isEditInventoryModalOpen, setIsEditInventoryModalOpen] =
    useState(false);
  const [selectedInventory, setSelectedInventory] = useState<any>(null);
  const [searchValue, setSearchValue] = useState("");
  const [searchFields] = useState([
    "serviceCenter",
    "salesOrderNumber",
    "itemNumber",
  ]);
  const [filtersReset, setFiltersReset] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  // Get service center state from Redux
  const { selectedServiceCenter, selectedServiceCenters } = useSelector(
    (state: any) =>
      state.inventoryServiceCenter || {
        selectedServiceCenter: null,
        selectedServiceCenters: [],
      }
  );
  const [selectedSpareParts, setSelectedSpareParts] = useState([]);
  const [selectedSalesOrderNumbers, setSelectedSalesOrderNumbers] = useState(
    []
  );
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [expandedRowKeys, setExpandedRowKeys] = useState<string[]>([]);
  const [expandedDetails, setExpandedDetails] = useState<Record<string, any[]>>(
    {}
  );
  const [expandedPages, setExpandedPages] = useState<Record<string, number>>(
    {}
  );
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);

  const profileData = useSelector((state: any) => state?.userProfile?.data);
  const isServiceCenter =
    profileData?.companyRoles[0]?.role?.roleName === "Service Center";

  const isEmployee =
    profileData?.companyRoles[0]?.role?.roleName === "3nStar Employee 1";

  const isAdmin =
    profileData?.companyRoles[0]?.role?.roleName === "Admin 3nStar";

  // Check if user has delete permissions (Super Admin/Super User roles)
  const canDelete =
    profileData?.companyRoles[0]?.role?.roleName === "Super Admin" ||
    profileData?.companyRoles[0]?.role?.roleName === "Super User" ||
    profileData?.companyRoles[0]?.role?.roleName === "Admin 3nStar";

  // const handleCancel = () => {
  //   setIsAddInventoryModalOpen(false);
  // };

  const showAddInventoryModal = () => {
    setIsAddInventoryModalOpen(true);
  };

  const handleStatusChange = (data: any) => {
    setSelectedStatus(data);
  };

  const showEditInventoryModal = (inventoryData: any) => {
    setSelectedInventory(inventoryData);
    setIsEditInventoryModalOpen(true);
  };

  const tableChangeHandler = (pagination: any, filters: any, sorter: any) => {
    setTotalRecords(pagination.total);
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
    setSortOrder(
      sorter?.order === "ascend" ? "asc" : sorter?.order ? "desc" : ""
    );
    setSortField(sorter.field);
  };

  const performSearchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchValue(value);
    setCurrentPage(1);
    // fetchAllInventoryDetails();
  };

  const fetchAllInventoryDetails = async (params?: any) => {
    try {
      const query = {
        page: params?.pageNumber || currentPage,
        pageSize: params?.pageSize || pageSize,
        sortBy: sortField,
        sortOrder: sortOrder,
        searchValue: searchValue?.trim(),
        status: selectedStatus,
        serviceCenterId: params?.serviceCenterId
          ? params.serviceCenterId
          : selectedServiceCenters,
        itemNumber: selectedSpareParts,
        salesOrderNumber: selectedSalesOrderNumbers,
        startDate: fromDate ? dayjs(fromDate).format("YYYY-MM-DD") : null,
        endDate: toDate ? dayjs(toDate).format("YYYY-MM-DD") : null,
      };
      setExpandedRowKeys([]);
      setExpandedDetails({});
      setExpandedPages({});
      setIsLoading(true);
      const response = await getApi("/inventory/inventory-list", query);
      const { total, data: inventoryDetails } = response.data.data;

      setAllInventoryData(inventoryDetails);
      await refetchCounts();
      setTotalRecords(total);
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.error?.message || "Failed to fetch inventory";
      const errorCode = error.response?.data?.error?.code;

      if (errorCode === 403) {
        toastText("You don't have permission to view inventory", "error");
      } else if (errorCode === 404) {
        toastText("No inventory found", "warning");
      } else {
        toastText(errorMessage, "error");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleOk = () => {
    setExpandedRowKeys([]);
    setExpandedDetails({});
    setExpandedPages({});
    console.log("selectedSalesOrderNumbers: ", selectedSalesOrderNumbers);
    fetchAllInventoryDetails();
  };
  const handleServiceCenterChange = (data: any) => {
    // Update Redux state
    dispatch(
      setServiceCenterSelection({
        selectedServiceCenter: data,
        selectedServiceCenters: data,
      })
    );

    fetchAllInventoryDetails({
      serviceCenterId: data,
      pageNumber: 1,
      pageSize: 10,
    });
  };
  const handleSparePartsChange = (data: any) => {
    setSelectedSpareParts(data);
  };

  const handleFromDateChange = (date: any) => {
    setFromDate(date);
  };

  const handleToDateChange = (date: any) => {
    setToDate(date);
  };
  const handleSalesOrderNumberChange = (data: any) => {
    setSelectedSalesOrderNumbers(data);
  };
  useEffect(() => {
    fetchAllInventoryDetails();
  }, [searchValue, currentPage, pageSize, sortField, sortOrder]);

  useEffect(() => {
    if (filtersReset) {
      fetchAllInventoryDetails({
        pageNumber: 1,
        pageSize: 10,
      });
      setFiltersReset(false);
    }
  }, [filtersReset]);

  // Delete functionality
  const handleDeleteClick = () => {
    if (selectedRowKeys.length > 0) {
      setIsDeleteModalOpen(true);
    }
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
  };

  const handleDeleteConfirm = async () => {
    if (selectedRowKeys.length === 0) return;

    setIsDeleteLoading(true);
    try {
      // Delete each inventory item individually
      const deletePromises = selectedRowKeys.map((id) =>
        deleteApiWithData("/inventory/delete", { inventoryId: id })
      );

      await Promise.all(deletePromises);

      toastText("Inventory items deleted successfully", "success");
      setSelectedRowKeys([]);
      setIsDeleteModalOpen(false);
      // Refresh the data
      fetchAllInventoryDetails();
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.error?.message ||
        "Failed to delete inventory items";
      toastText(errorMessage, "error");
    } finally {
      setIsDeleteLoading(false);
    }
  };

  // Row selection configuration - only enable if user has delete permissions
  const rowSelection = canDelete
    ? {
        onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
          setSelectedRowKeys(selectedRowKeys as string[]);
        },
        getCheckboxProps: (record: any) => ({
          disabled: false,
        }),
      }
    : undefined;
  return (
    <>
      <div>
        <TableActionHeader title={"Receive Inventory"}></TableActionHeader>

        <InventoryTable
          allInventoryData={allInventoryData}
          isLoading={isLoading}
          onEdit={showEditInventoryModal}
          currentPage={currentPage}
          pageSize={pageSize}
          totalRecords={totalRecords}
          tableChangeHandler={tableChangeHandler}
          isServiceCenter={isServiceCenter}
          isEmployee={isEmployee}
          searchValue={searchValue}
          performSearchHandler={performSearchHandler}
          searchFields={searchFields}
          handleServiceCenterChange={handleServiceCenterChange}
          selectedServiceCenter={selectedServiceCenters}
          handleSparePartsChange={handleSparePartsChange}
          selectedSpareParts={selectedSpareParts}
          handleFromDateChange={handleFromDateChange}
          handleToDateChange={handleToDateChange}
          fromDate={fromDate}
          toDate={toDate}
          handleSalesOrderNumberChange={handleSalesOrderNumberChange}
          selectedSalesOrderNumbers={selectedSalesOrderNumbers}
          handleOk={handleOk}
          fetchInventory={fetchAllInventoryDetails}
          isAdmin={isAdmin}
          sortDirection={sortOrder}
          handleStatusChange={handleStatusChange}
          selectedStatus={selectedStatus}
          expandedRowKeys={expandedRowKeys}
          expandedDetails={expandedDetails}
          expandedPages={expandedPages}
          setExpandedRowKeys={setExpandedRowKeys}
          setExpandedDetails={setExpandedDetails}
          setExpandedPages={setExpandedPages}
          setFiltersReset={setFiltersReset}
          rowSelection={rowSelection}
          selectedRowKeys={selectedRowKeys}
          handleDeleteClick={handleDeleteClick}
          canDelete={canDelete}
        />

        {isAddInventoryModalOpen ? (
          <InventoryTableNew
            open={isAddInventoryModalOpen}
            onCancel={() => {
              setIsAddInventoryModalOpen(false);
            }}
            fetchInventoryTable={fetchAllInventoryDetails}
          />
        ) : null}

        {isEditInventoryModalOpen && (
          <InventoryEditModal
            open={isEditInventoryModalOpen}
            onCancel={() => setIsEditInventoryModalOpen(false)}
            inventoryData={selectedInventory}
            fetchInventory={fetchAllInventoryDetails}
            isAdmin={isAdmin}
          />
        )}

        <ConfirmDelete
          isModalOpen={isDeleteModalOpen}
          handleCancel={handleDeleteCancel}
          handleOk={handleDeleteConfirm}
          deleteHandler={handleDeleteConfirm}
          isAddUserLoading={isDeleteLoading}
          warningMessage="Deleting this record will affect Receive Inventory and Shipments. This action cannot be undone. Proceed only if you are certain."
        />
      </div>
    </>
  );
};

export default ReceiveInventoryComponent;
